const getLoadingStatus = state => state.geoBasic.isLoading;

const getSelectOptions = state => state.geoBasic.selectOptions;

const geSingleObjectName = state => state.geoBasic.singleObjectName;

export { getLoadingStatus, getSelectOptions, geSingleObjectName };
